import React, { useEffect, useRef } from 'react';
import { useNumber } from 'react-hanger';
import cls from 'classnames';
import times from 'lodash/times';

import { UiScroll } from '@/components';
import { ItemProps } from '../types';
import Styled from './styled';

const ImagePicker = (
  props: ItemProps & { options?: any; isSlide?: boolean; pageSize?: number },
) => {
  const {
    className,
    label,
    name,
    value,
    disabled,
    onChange,
    options,
    isSlide,
    pageSize = 3,
  } = props;

  const scrollRef = useRef<HTMLDivElement>();
  const currentPage = useNumber(1);
  const allPage = Math.ceil(options.length / pageSize);

  const enableEnv = {
    left: currentPage.value > 1,
    right: allPage > 1 && currentPage.value < allPage,
  };

  const valueLabel =
    options.find((item) => {
      return item.value === value;
    })?.label || '';

  useEffect(() => {
    if (!valueLabel && options.length) {
      onChange(name, options[0]?.value, options[0]);
    }
  }, [options, valueLabel]);

  useEffect(() => {
    if (isSlide) {
      scrollRef.current.scrollTo({
        left: (currentPage.value - 1) * scrollRef.current.offsetWidth,
        behavior: 'smooth',
      });
    }
  }, [currentPage.value]);

  const handleChange = (nextValue, e, nextItem) => {
    if (!disabled) {
      onChange(name, nextValue, nextItem);
      if (!isSlide) {
        e.currentTarget.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
        });
      }
    }
  };

  const handleSlideLeft = () => {
    if (enableEnv.left) {
      currentPage.decrease();
    }
  };

  const handleSlideRight = () => {
    if (enableEnv.right) {
      currentPage.increase();
    }
  };

  return (
    <Styled.ImagePicker
      className={cls('form-item', 'form-item-imagepicker', className, {
        'is-slide': isSlide,
        disabled,
      })}
    >
      <label className="form-item-label">{label}</label>
      {isSlide && (
        <ul className="form-item-nav">
          <li
            className={cls('form-item-nav-left iconfont icon-backward', {
              disabled: !enableEnv.left,
            })}
            onClick={handleSlideLeft}
          />
          <li
            className={cls('form-item-nav-left iconfont icon-forward', {
              disabled: !enableEnv.right,
            })}
            onClick={handleSlideRight}
          />
        </ul>
      )}
      <UiScroll
        dark={true}
        overflowX
        ref={scrollRef}
        overflowY={false}
        className="form-item-options"
      >
        <ul>
          {times(allPage * pageSize, (index) => {
            const item = options[index];

            if (!item) {
              return <li key={index} />;
            }

            const isActive = item.value === value;
            return (
              <li
                key={item.value}
                className={cls({ active: isActive })}
                onClick={(e) => {
                  return handleChange(item.value, e, item);
                }}
              >
                <img src={item.img || item.value} />
                <span> {item.label}</span>
              </li>
            );
          })}
        </ul>
      </UiScroll>
    </Styled.ImagePicker>
  );
};

export default ImagePicker;
